module.exports = __webpack_public_path__ + "static/puffins-zoom-957f8270e27bd8cf5ff86a9b19818003.jpg";